import { createFileRoute, redirect } from "@tanstack/react-router";
import { isStaffAuthenticated } from "../lib/auth-session.ts";

export const Route = createFileRoute("/")({
  beforeLoad: () => {
    throw redirect({ to: isStaffAuthenticated() ? "/today" : "/login" });
  },
});
